import { getCompanyDefaultLanguage, getCurrentLanguage } from '~/localization';

export const APIs = {
  enum: {
    listValuesByGroup: (
      group: string,
      companyDefaultLanguage = getCompanyDefaultLanguage(),
    ) => `/json/enum/${group}/${companyDefaultLanguage}?includeInactive=false`,
    translation: (group: string, code: string) =>
      `/json/enum/${group}/v/${code}/loc`,
    details: (group: string, code: string) =>
      `/json/enum/${group}/v/${code}/details`,
    add: (group: string) => `/json/enum/${group}/v`,
    get: (group: string, name: string) => `/json/enum/${group}/d/${name}`,
    update: (group: string, code: string) => `/json/enum/${group}/v/${code}/`,
    groupCodes: (
      group: string,
      companyDefaultLanguage = getCompanyDefaultLanguage(),
    ) => `/json/enum/${group}/${companyDefaultLanguage}?includeInactive=false`,
    group: (group: string) => `/json/enum/${group}/v`,
    groupCode: (group: string, code: string) => `/json/enum/${group}/v/${code}`,
    groupTags: (group: string) => `/json/enum/${group}/tag`,
    all: (currentLanguage = getCurrentLanguage()) =>
      `/json/enum/ALL/${currentLanguage}`,
    allWithConfig: '/json/enum?format=all',
    order: (group: string) => `/json/enum/${group}/order`,
    currentVersion: '/json/enum/currentVersion',
    customFieldAttribute: (name: string) =>
      `/json/customdata/entity/${name}/attribute`,
    updateCustomFieldAttribute: (group: string, code: string) =>
      `/json/customdata/entity/${group}/attribute/${code}`,
    deleteCustomFieldAttribute: (group: string, code: string) =>
      `/json/customdata/entity/${group}/attribute/${code}/h`,
    customFields: (name: string, iEmpId: string) =>
      `/json/customdata/${name}/${iEmpId}`,
  },
};
